
export interface IModalButton {
    text: string,
    callback: Function,
    buttonType: IModalButtonType,
    icon?: string
}


export interface IModalConfirmation {
    icon: string,
    header: string,
    message: string,
    leftButtons?: IModalButton[],
    rightButtons: IModalButton[],
    closeCallback?: Function
}

export enum IModalButtonType {
    OUTLINE_DEFAULT = 'outline-default',
    PRIMARY = 'primary'
}

export interface IModalConfirmationForDeleteAndRestore {
    message: string,
    apiURL?: string,    
    method?:string,
    row?: any,
    callbackFn: Function,
    icon: string,
    header: string,
}
